import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { CustomerType } from "../state/types"

export const useCustomerTypeActions = () => {
    const saveActions = useSaveActions()

    const saveCustomerType = (customerType: CustomerType) => {
        const { save } = saveActions()
        return save(TableName.CUSTOMER_TYPES, customerType) as Promise<CustomerType>
    }

    const saveCustomerTypes = (customerTypes: CustomerType[]) => {
        const { saveMultiple } = saveActions()
        return saveMultiple(TableName.CUSTOMER_TYPES, customerTypes) as Promise<CustomerType[]>
    }

    const removeCustomerType = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.CUSTOMER_TYPES, id)
    }

    return {
        saveCustomerType,
        saveCustomerTypes,
        removeCustomerType
    }
} 